<div class="section-tabs">
  @for (tab of tabs(); track tab.value) {
    @if (tab.show !== false) {
      <button type="button"
        [class.active]="selected() === tab.value"
        [attr.aria-pressed]="selected() === tab.value"
        [ngClass]="tab.cssClass ?? []"
        (click)="selectedChange.emit(tab.value)">
        {{ tab.labelKey | translate }} @if (tab.count != null) { ({{ tab.count }}) }
      </button>
    }
  }
</div>